<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { LogEvent } from '@/maintenance/types'
import ViewerJSON from '@/maintenance/ViewerJSON.vue'
import ViewerXML from '@/maintenance/ViewerXML.vue'
import { useStore } from '@/store'
import { PmsiTypeEnum } from '@/store/modules/settings/types'

const store = useStore()
const { t } = useI18n()

defineProps<{
  pmsiType: PmsiTypeEnum
}>()

const shownLogEvent = computed<LogEvent>(() => store.getters.shownLogEvent)
const messageType = computed(() => getMessagetype(shownLogEvent.value.message))
const responseType = computed(() => getMessagetype(shownLogEvent.value.response))

function getMessagetype(message: string): string {
  switch (message.trim()[0]) {
    case '[':
    case '{':
      return 'json'
    case '<':
      return 'xml'
    default:
      return 'raw'
  }
}

function navigateToLog(move) {
  store.commit('moveLogEventShown', move)
}
</script>

<template>
  <div
    v-if="shownLogEvent"
    class="w-100 ps-5 pe-5"
  >
    <div class="card">
      <div class="card-body">
        <div class="row justify-content-between align-baseline g-0 mb-3">
          <router-link :to="{ name: 'maintenance-event-observer', params: {pmsiType}, hash: `#event-${shownLogEvent.id}`}">
            &lt; {{
              t('maintenance.eventObserver.title')
            }}
          </router-link>
          <div>
            <button
              class="btn btn-outline-primary me-1"
              @click="navigateToLog(-1)"
            >
              {{ t('maintenance.eventViewer.previous') }}
            </button>
            <button
              class="btn btn-outline-primary ms-1"
              @click="navigateToLog(+1)"
            >
              {{ t('maintenance.eventViewer.next') }}
            </button>
          </div>
        </div>
        <div class="w-100 h-100">
          <table
            class="table"
            style="table-layout: fixed;"
          >
            <tbody>
              <tr
                v-for="(dataContent, dataName) in shownLogEvent"
                :key="dataName"
              >
                <td
                  class="align-top fw-bold"
                  style="width: 250px;"
                >
                  <span class="float-end pe-3">{{ dataName }} :</span>
                </td>
                <td class="align-top">
                  <div v-if="(dataName === 'message' && messageType === 'json') || dataName === 'response' && responseType === 'json'">
                    <ViewerJSON :data="dataContent.toString()" />
                  </div>
                  <div v-else-if="(dataName === 'message' && messageType === 'xml') || (dataName === 'response' && responseType === 'xml')">
                    <ViewerXML :data="dataContent.toString()" />
                  </div>
                  <div v-else>
                    <pre>{{ dataContent }}</pre>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
